// /** 사용자 목록 조회 */
// export const GET_MEMBERS = "GET_MEMBERS";

/** 복사 붙여넣기 */
/** 권한 그룹별 목록 조회 */
export const GET_GROUP_PERMISSIONS = "GET_GROUP_PERMISSIONS";

/** 권한 목록 조회 */
export const GET_PERMISSIONS = "GET_PERMISSIONS";

/** 사용자 목록 조회 */
export const GET_MEMBERS = "GET_MEMBERS";

/** 권한 select options 조회 */
export const GET_PERMISSION_SELECT_OPTIONS = "GET_PERMISSION_SELECT_OPTIONS";

/** 함형 SELECT OPTIONS 조회 */
export const GET_SHIP_TYPE_SELECT_OPTIONS = "GET_SHIP_TYPE_SELECT_OPTIONS";

/** 함정 SELECT OPTIONS 조회 */
export const GET_SHIP_SELECT_OPTIONS = "GET_SHIP_SELECT_OPTIONS";

/** 장비 SELECT OPTIONS 조회 */
export const GET_MACHINERY_SELECT_OPTIONS = "GET_MACHINERY_SELECT_OPTIONS";

/** 하위장비(계통) SELECT OPTIONS 조회 */
export const GET_LOW_MACHINERY_SELECT_OPTIONS =
  "GET_LOW_MACHINERY_SELECT_OPTIONS";

/** 센서 SELECT OPTIONS 조회 */
export const GET_SENSOR_SELECT_OPTIONS = "GET_SENSOR_SELECT_OPTIONS";

/** 문서 유형 SELECT OPTIONS 조회 */
export const GET_TECH_DOC_SELECT_OPTIONS = "GET_TECH_DOC_SELECT_OPTIONS";

/** 사용자 목록 조회 */
export const GET_SEARCH_LOGINLOGS = "GET_SEARCH_LOGINLOGS";

/** 데이터 파일 조회 */
export const GET_DATA_FILES = "GET_DATA_FILES";

/** 센서 데이터 조회 */
export const GET_SENSOR_DATA = "GET_SENSOR_DATAS";

/** 센서 데이터 총 개수 조회 */
export const GET_SENSOR_DATA_COUNT = "GET_SENSOR_DATA_COUNT";

/** 상태진단 알람 조회 */
export const GET_STATUS = "GET_STATUS";

/** ecs 알람 조회 */
export const GET_ECS_ALARM = "GET_ECS_ALARM";

/** 기술문서 관리 조회 */
export const GET_TECH_DOC = "GET_TECH_DOC";

/** 장비 부호관리 조회 */
export const GET_EQUIPMENT_CODE = "GET_EQUIPMENT_CODE";

/** ECS 알람 조회 */
export const GET_ECS_ALARMS = "GET_ECS_ALARMS";

/** 함형 목록 조회 */
export const GET_SHIP_TYPES = "GET_SHIP_TYPES";

/** 함정 목록 조회 */
export const GET_SHIPS = "GET_SHIPS";

/** 함정 정보 관리 조회 */
export const GET_SHIPS_INFO = "GET_SHIPS_INFO";

/** 장비 운용현황 조회 */
export const GET_EQUIPMENT_OPERATION_STATUS = "GET_EQUIPMENT_OPERATION_STATUS";

/** 장비 운용현황 VDS 조회 */
export const GET_EQUIPMENT_OPERATION_VDS = "GET_EQUIPMENT_OPERATION_VDS";

/** 장비 운용현황 DDU 조회 */
export const GET_EQUIPMENT_OPERATION_DDU = "GET_EQUIPMENT_OPERATION_DDU";

/** 보고서 리스트 조회 */
export const GET_REPORT_LIST = "GET_REPORT_LIST";

/** 보고서 파일 업로드 */
export const POST_REPORT_FILE_UPLOAD = "POST_REPORT_FILE_UPLOAD";

/** 해당 보고서 첨부 파일 가져오가 */
export const GET_REPORT_FILE = "GET_REPORT_FILE";

/** 함정 운용현황 조회 */
export const GET_SHIP_OPERATION_STATUS = "GET_SHIP_OPERATION_STATUS";

/** 장비 정보 관리 조회 */
export const GET_EQUIPMENT_INFO = "GET_EQUIPMENT_INFO";

/** 장비 정보 관리 파일 데이터 조회 */
export const GET_EQUIPMENT_INFO_FILE = "GET_EQUIPMENT_INFO_FILE";
/** 저장소 조회 */
export const GET_DRIVE = "GET_DRIVE";

/** 보고서 유형 조회 (진단, 이상탐지, 고장) */
export const GET_REPORT_TYPES = "GET_REPORT_TYPES";

/** 상태진단 알람 실행시간 */
export const GET_STATUS_ALRAM = "GET_STATUS_ALRAM";

/** 데이터 송수신 모니터링 */
export const GET_DATA_MONITORING = "GET_DATA_MONITORING";

/** 데이터 로그 */
export const GET_DATA_LOG = "GET_DATA_LOG";
export const GET_DATA_LOG_COUNT = "GET_DATA_LOG_COUNT";

/** 데이터 백업내역 조회 */
export const GET_BACKUP_DATAS = "GET_BACKUP_DATAS";

/** (SSD) DB 저장소 공간 상태
 *  (HDD) 백업 저장소 공간 상태
 * */
export const GET_DB_STORAGE_DATA = "GET_DB_STORAGE_DATA";

/** DB 자동백업 설정 조회 */
export const GET_BACKUP_SETTING = "GET_BACKUP_SETTING";

/** 장비모니터링>계통별알람현황 */
export const GET_EQUIPMENT_ALARM_STATUS_BY_SYSTEM =
  "GET_EQUIPMENT_ALARM_STATUS_BY_SYSTEM";

/** 장비모니터링>개요>장비현황>장비알람조치 현황 */
export const GET_EQUIPMENT_ALARM_ACTION_STATUS =
  "GET_EQUIPMENT_ALARM_ACTION_STATUS";

/** 장비모니터링>개요>장비현황>장비알림현황 */
export const GET_EQUIPMENT_ALARM_STATUS = "GET_EQUIPMENT_ALARM_STATUS";

/** 장비모니터링>계통별알람현황 > LED */
export const GET_EQUIPMENT_ALARM_STATUS_BY_SYSTEM_LED =
  "GET_EQUIPMENT_ALARM_STATUS_BY_SYSTEM_LED";

/** 장비모니터링>개요>장비 운용 현황  */
export const GET_EQUIPMENT_OPERATION_STATUS_TIME =
  "GET_EQUIPMENT_OPERATION_STATUS_TIME";

/** 장비모니터링>개요>장비현황>센서알림현황 */
export const GET_EQUIPMENT_SENSOR_ALARM_STATUS =
  "GET_EQUIPMENT_SENSOR_ALARM_STATUS";

/** [ 모달 ] 장비모니터링> 상태진단 데이터조회 > 센서 상태진단 알람통계 차트 && Anomaly Score 차트 */
export const GET_ALARM_STATISTIC_CHART_DATA = "GET_ALARM_STATISTIC_CHART_DATA";

/** Scatter Analysis 차트 */
export const GET_SCATTER_ANALYSIS_CHART_DATA =
  "GET_SCATTER_ANALYSIS_CHART_DATA";

/**  Time Series Analysis 차트  */
export const GET_TIME_SERIES_ANALYSIS_CHART_DATA =
  "GET_TIME_SERIES_ANALYSIS_CHART_DATA";

/** 장비모니터링> 상태진단 데이터조회 > 센서별 알람 발생 히트맵 */
export const GET_ALARM_HEATMAP_LIST = "GET_ALARM_HEATMAP_LIST";

/** 장비모니터링> 상태진단 데이터조회 > 하위장비/센서별 상태진단 알람 발생 통계 ( 테이블 )  */
export const GET_ALARM_STATICSTICS_TABLE = "GET_ALARM_STATICSTICS_TABLE";

/** 장비모니터링>상태진단 데이터 조회 장비/센서 목록 리스트 */
export const GET_STATUS_DIAGNOSIS_DATA_LIST = "GET_STATUS_DIAGNOSIS_DATA_LIST";

/** 장비모니터링> 장비운용현황 > 알람현황전체 */
export const GET_EQUIPMENT_ALARM_STATUS_ALL = "GET_EQUIPMENT_ALARM_STATUS_ALL";

/** Scat */
export const GET_EQUIPMENT_OPERATION_STATUS_LED =
  "GET_EQUIPMENT_OPERATION_STATUS_LED";

/**Trend Chart 데이터  */
export const GET_TREND_CHART_DATA = "GET_TREND_CHART_DATA";
